// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css';
import '@/assets/less/index.less'


//导入mqtt
import '@/util/mqtt'
//引入全局过滤器
import './filters'
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false
import BaiduMap from 'vue-baidu-map'
import waterfall from 'vue-waterfall2'
import * as echarts from 'echarts'
import 'echarts-gl'
Vue.prototype.$echarts = echarts
Vue.use(waterfall)
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'YOUR_APP_KEY'
})

// 防止连点
Vue.directive('throttle', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      el.style.pointerEvents = 'none'
      if (!el.disabled) {
        setTimeout(() => {
          el.style.pointerEvents = 'auto'
        }, binding.value || 2000)
      }
    })
  }
})


//引入公共js方法
import common from '@/util/common.js'
Vue.prototype.common=common;
//引入缓存数据设置js
import storage from "@/util/changeStorage.js"//
Vue.prototype.$storage=storage;


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js